import React from "react";

export default function BadgeCard({ title,compact, subtitle, icon, active }) {
  return (
  <div
      className={`
        ${compact ? "sm:w-[200px]" : "sm:w-[200px]"}
        w-[200px] shrink-0 min-h-[200px] max-sm:min-h-[160px] max-sm:w-[160px] max-sm:h-[160px]
        rounded-2xl bg-badge-bg shadow-md
        flex flex-col items-center justify-center text-center
        px-4 max-xl:px-2 py-6 transition-all
        ${active ? "border-2 border-[#1D3557]" : "border border-transparent"}
      `}
    >
      <img src={icon} alt={title} className="w-12 h-12 xxl1:w-20 xxl1:h-20 mb-3" />

      <h3 className="font-manrope font-semibold text-[16px] max-xl:text-sm xxl1:text-lg text-[#1b1b1b]">
        {title}
      </h3>

      {subtitle && (
        <p className="text-xs xxl1:text-sm text-[#0F1D2E] mt-1">{subtitle}</p>
      )}
    </div>
  );
}
